import React, { useMemo } from 'react';
import { Button } from '@/components/generic';
import { bitcoinChain, useChainStore } from '@package/smart-wallet';
import { useAccount } from 'wagmi';

export const SuccessStatus = ({
  title = 'Process Complete',
  content,
  onClose,
  confirm,
  txHash,
}: {
  title?: string;
  content?: string | React.ReactNode;
  onClose?: () => void;
  confirm?: () => void;
  txHash?: string;
}) => {
  const chainId = useChainStore((state) => state.chainId);
  const { chain } = useAccount();

  const blockExplorerUrl = useMemo(() => {
    if (chainId === bitcoinChain.id) {
      return `https://mempool.space/tx/${txHash}`;
    }
    return chain?.blockExplorers?.default.url + '/tx/' + txHash;
  }, [chainId, chain?.blockExplorers?.default.url, txHash]);

  return (
    <>
      <div className='flex justify-center items-center size-16 mb-8 bg-primary-02/15 rounded-full'>
        <span className='text-t-primary text-3xl'>🎉</span>
      </div>
      <div className='mb-4 text-h4 max-md:text-h5 text-t-primary'>{title}</div>
      <div className='mb-8 text-body-2 font-medium text-t-tertiary'>
        {content}
      </div>
      <div className='flex justify-end gap-3 mt-8'>
        <Button className='flex-1' isStroke onClick={onClose}>
          Close
        </Button>
        {txHash ? (
          <Button
            as='a'
            href={blockExplorerUrl}
            target='_blank'
            rel='noopener noreferrer'
            className='flex-1'
            isBlack
          >
            View Transaction
          </Button>
        ) : (
          <Button className='flex-1' isBlack onClick={confirm}>
            Continue
          </Button>
        )}
      </div>
    </>
  );
};
